module.exports = __webpack_public_path__ + "media/images/shared/suppliers/DIESELTECHNIC-81598bfb6ce6f33e7b56aa5684c0f3ac.jpg";